import Grid from "@mui/material/Grid";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import AnimatedHeight from "../customComponents/AnimatedHeight";

const pageSx = {
  background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
  marginTop: "-64px",
};

const cardSx = {
  bgcolor: "white",
  borderRadius: 4,
  boxShadow: 4,
  p: { xs: 4, sm: 8 },
  maxWidth: 450,
};

const SLIDE_DISTANCE = 40;

// Moving forward slides the next step in from the right, going back slides it in from the left
const stepVariants = {
  enter: (offset) => ({ opacity: 0, x: offset }),
  center: { opacity: 1, x: 0 },
  exit: (offset) => ({ opacity: 0, x: -offset }),
};

const stepTransition = { duration: 0.22, ease: "easeOut" };

// Card of the pre-login pages (login, forgot and reset password). When `step` changes the content
// slides over and the card resizes to fit; `direction` is 1 for moving forward and -1 for going back.
export default function AuthCard({ step, direction = 1, children }) {
  const reduceMotion = useReducedMotion();
  const slideOffset = reduceMotion ? 0 : direction * SLIDE_DISTANCE;

  return (
    <Grid
      container
      item
      height="100vh"
      width="100%"
      justifyContent="center"
      alignItems="center"
      sx={pageSx}
    >
      <Grid container item xs={12} sm={8} md={6} xl={4} direction="column" sx={cardSx}>
        <AnimatedHeight>
          <AnimatePresence exitBeforeEnter initial={false} custom={slideOffset}>
            <motion.div
              key={step}
              custom={slideOffset}
              variants={stepVariants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={stepTransition}
            >
              {children}
            </motion.div>
          </AnimatePresence>
        </AnimatedHeight>
      </Grid>
    </Grid>
  );
}
